// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/fontawesome-free/css/fontawesome.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/logos/KassetHorizontalLogoPlain.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/logos/Kasset.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assetTableList{
    width: 63%;
    margin: auto;
    margin-left: 14%;
    border: solid black 1px;
    border-radius: 8px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    overflow: hidden;
}

.assetIDHeader{
  color: white;
  font-size: 37px;
  margin-left: 5%;
  margin-top: -10%;
}

.assetTableList tbody tr:nth-child(even){
    background-color: dimgray;
    color: white;
}

.assetTableList tbody tr:nth-child(odd){
    background-color: rgb(61, 61, 61);
    color: white;
}

.assetTableList tr{
    height: 40px;
    transition: background-color 0.4s ease, transform 0                                                                                   .2s ease;
    
}

.assetTableList thead{
    color: white;
    height: 40px;
    background-color: #059bd4ff;
}

.assetTableList th{
    border: solid  rgba(58, 57, 57, 0.251) 1px;
    border-collapse: collapse;
    text-align: center;
    
}

.assetTableList td{
    border: solid  black 1px;
    border-collapse: collapse;
    text-align: center;
    height: 100%;
}

.assetTableList tr:hover {
  background-color: rgb(3, 83, 114) !important; /* Change to your desired highlight color */
}

.logo {
    grid-row-start: 1;
    grid-row-end: 2;
    height: 10%;
    width: 90%;
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    z-index: 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sideNav {
  display: block;
  height: 100%;
  width: 13%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 20px;
}

.checkbox{
  height: 25px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0;
  width: 25px;
}

.sideNav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #059bd4ff !important;
  display: block;
  transition: 0.3s;
  border-bottom: solid #000000 1px;
}

h2 {
  color: white;
  margin-left: 40%;
}

h1 {
  color: white;
  margin-left: 14%;
}

.sideNav h5{
  position: absolute;
  bottom: 0;
  padding-bottom: 10px;
  padding-left: 20px;
  color: rgb(4, 105, 145) !important;
}

.sideNav a:hover {
  color: rgb(4, 105, 145) !important;
}

.sideNavLinks{
    margin-top: 15px;
}

.sideEdit {
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.3s ease;
  padding-top: 60px;
}

.sideEdit input, select{
    display: grid;
    border-radius: 5px;
}

.sideEditForm{
    display: grid;
    grid-template-columns: 40% 60%;
    margin-right: 3%;
    margin-left: 3%;
}

.sideEdit .closeEditMenu {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 24px;
  margin-left: 50px;
  margin-top: 3%;
  border: none;
  background-color: rgba(0,0,0,0);
  color: white;
}

.textbox {
    display: grid;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #fff;
    background-color: rgb(28,28,30);
    box-shadow: 0 0 .4vw rgba(0,0,0,0.5), 0 0 0 .15vw transparent;
    border-radius: 0.4vw;
    border: none;
    outline: none;
    padding: 10px;
    width: 100%;
    transition: .4s;
    margin-top: 10px;
    margin-bottom: 10px;
    }

.textbox:hover {
  box-shadow: 0 0 0 .15vw rgba(135, 207, 235, 0.186);
}

.textbox:focus {
  box-shadow: 0 0 0 .15vw skyblue;
}

.searchbox {
    display: grid;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: .6vw;
    color: #fff;
    background-color: rgb(28,28,30);
    box-shadow: 0 0 .4vw rgba(0,0,0,0.5), 0 0 0 .15vw transparent;
    border-radius: 0.4vw;
    border: none;
    outline: none;
    padding: 10px;
    width: 100%;
    transition: .4s;
    margin-top: 10px;
    margin-bottom: 10px;
}

.searchbox:hover {
  box-shadow: 0 0 0 .15vw rgba(135, 207, 235, 0.186);
}

.searchbox:focus {
  box-shadow: 0 0 0 .15vw skyblue;
}

.searchControls{
    width: 20%;
    margin-left: 14%;
    display: grid;
    grid-template-columns: 60% 40%;
}

.inputLabel{
    display: grid;
    width: 100%;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-size: 20px;
    color: white;
    margin: auto;
    justify-content: left;
}

.numberSelector{
    margin: auto;
    width: 150px;
    max-height: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.selectSelector{
  margin-left: none;
    width: 100%;
    max-height: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.sideEdit a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #059bd4ff !important;
  display: block;
  transition: 0.3s;
  border-bottom: solid #000000 1px;
}

.sideEdit h5{
  position: absolute;
  bottom: 0;
  padding-bottom: 10px;
  padding-left: 20px;
  color: rgb(4, 105, 145) !important;
}

.sideEdit a:hover {
  color: rgb(4, 105, 145) !important;
}

.sideEditLinks{
    margin-top: 15px;
}

.updateButton{
    color: white;
    background-color: rgb(4, 101, 139);
    width: 46%;
    margin-left: 2%;
    height: 35px;
    border: none;
    border-radius: 10px;
    transition: background-color 0.1s ease-in;
}

.updateButton:hover{
    background-color: rgb(1, 68, 94);
}

.searchButton{
    color: white;
    background-color: rgb(4, 101, 139);
    width: 40%;
    height: 35px;
    border: none;
    border-radius: 10px;
    margin: auto;
    margin-left: 5%;
    transition: background-color 0.1s ease-in;
}

.searchButton:hover{
    background-color: rgb(1, 68, 94);
    transition: background-color 0.1s ease-in;
}

.deleteButton{
    color: white;
    background-color: rgb(157, 0, 0);
    width: 46%;
    margin-left: 2%;
    margin-top: 10%;
    height: 35px;
    border: none;
    border-radius: 10px;
    transition: background-color 0.1s ease-in;
}

.deleteButton:hover{
    background-color: rgb(107, 1, 1);
}

@media only screen and (min-width: 400px) {
    .loginPane {
        display:  grid;
        justify-content: center;
        grid-template-columns: auto;
        grid-template-rows: 500px 55px 55px 55px 55px;
        grid-row-gap: 3%;
        width: 20vw;
        min-width: 400px;
        min-height: 900px;
        height: 100%;
        margin: auto;
        margin-top: 5%;
        background-color: rgba(17, 17, 17, 1);
        border-radius: 10px;
        color: #ffffff;
        
    }

    .normalButtons{
        display: inline-block;
        margin: auto;
        outline: none;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        border-radius: 10px;
        transition-property: background-color,border-color,color,box-shadow,filter;
        transition-duration: .3s;
        border: 1px solid transparent;
        letter-spacing: 2px;
        min-width: 80px;
        text-transform: uppercase;
        white-space: normal;
        font-weight: 700;
        text-align: center;
        padding: 16px 14px 18px;
        color: #fff;
        background-color: #059bd4ff;
        height: 48px;
        width: 80%;
      }
      
      .normalButtons:hover {
        transition-duration: .3s;
        background-color: rgb(0, 121, 168);
      }
}

@media only screen and (max-width: 400px) {
    .loginPane {
        display: grid;
        justify-content: center;
        grid-template-columns: auto;
        grid-template-rows: 500px 55px 55px 55px 55px;
        grid-row-gap: 3%;
        width: 20vw;
        min-width: 100%;
        min-height: 600px;
        height: 100%;
        margin: auto;
        
        margin-top: 5%;
        background-color: rgba(17, 17, 17, 1);
        border-radius: 10px;
        color: #ffffff;
    }
    .normalButtons{
        display: inline-block;
        margin: auto;
        outline: none;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        border-radius: 10px;
        transition-property: background-color,border-color,color,box-shadow,filter;
        transition-duration: .3s;
        border: 1px solid transparent;
        letter-spacing: 2px;
        min-width: 80px;
        text-transform: uppercase;
        white-space: normal;
        font-weight: 700;
        text-align: center;
        padding: 16px 14px 18px;
        color: #fff;
        background-color: #059bd4ff;
        height: 48px;
        width: 80%;
      }
      
      .normalButtons:hover {
        transition-duration: .3s;
        background-color: rgb(0, 121, 168);
      }
}
/* body {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("../../../public/img/ticketbg.jpg");
    background-position: 0% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
} */


.linksButtons{
    display: inline-block;
    margin: 10px;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    border-radius: 10px;
    transition-property: background-color,border-color,color,box-shadow,filter;
    transition-duration: .3s;
    border: 1px solid transparent;
    letter-spacing: 2px;
    min-width: 80px;
    text-transform: uppercase;
    white-space: normal;
    font-weight: 700;
    text-align: center;
    padding: 16px 14px 18px;
    color: #fff;
    background-color: rgb(3, 74, 103);
    height: 48px;
    width: 220px;
}
    
.linksButtons:hover {
    transition-duration: .3s;
    background-color: rgb(0, 121, 168);
}

.title {
    display: grid;
    align-content: center;
    justify-content: center;
    grid-row-start: 2;
    grid-row-end: 3;
}

.title h1 {
    font-size: 42px;
    align-content: center;
    justify-content: center;
}

.smallLogo {
    grid-row-start: 1;
    grid-row-end: 2;
    height: 500px;
    width: 70%;
    margin: auto;
    margin-top: 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    z-index: 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.formInput {
    border: none;
    background: none;
    width: 85%;
    height: 60%;
    margin-top: 3%;
    margin-left: 5%;
    color: white;
}

.form-label {
    font-size: 120%;
    font-weight: bold;
}

.text-fields {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 25px;
    margin-top: 0px;
    height: 55px;
    margin: auto;
}

.body{
    background-color: rgba(0, 0, 0, 1);
}

.form{
    background-color: rgba(0, 0, 0, 1);
    height: 850px;
}

.loginRowEmail {
    display: flex;
    grid-row-start: 2;
    grid-row-end: 3;
    width: 90%;
}

.fa {
    margin-left: 10%;
    margin-top: 5.5%;
}

.loginRowPassword {
    display: flex;
    grid-row-start: 3;
    grid-row-end: 4;
    background-color: rgba(0, 0, 0, 0.5);
    width: 90%;
}

.btn-div {
    display: flex;
    grid-row-start: 4;
    grid-row-end: 5;
    
    width: 100%;
}

.links-div{
    display: flex;
    grid-row-start: 5;
    grid-row-end: 6;
    width: 100%;
}

.links{
    display: flex;
    width: 100%;
}

.loginFormGroup {
    width: fit-content;
    text-align: center;
}

.form-control {
    width: 75%;
    text-align: center;
}


`, "",{"version":3,"sources":["webpack://./src/home/assets.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,8IAA8I;;AAElJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;EACE,4CAA4C,EAAE,2CAA2C;AAC3F;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,yDAAyE;AAC7E;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,MAAM;EACN,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,YAAY;AACd;;AAEA;IACI,aAAa;IACb,oJAAoJ;IACpJ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,+BAA+B;IAC/B,6DAA6D;IAC7D,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;;AAEJ;EACE,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;IACI,aAAa;IACb,oJAAoJ;IACpJ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,+BAA+B;IAC/B,6DAA6D;IAC7D,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oJAAoJ;IACpJ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,iBAAiB;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAMA;IACI;QACI,cAAc;QACd,uBAAuB;QACvB,2BAA2B;QAC3B,6CAA6C;QAC7C,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,qCAAqC;QACrC,mBAAmB;QACnB,cAAc;;IAElB;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,aAAa;QACb,eAAe;QACf,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,0EAA0E;QAC1E,wBAAwB;QACxB,6BAA6B;QAC7B,mBAAmB;QACnB,eAAe;QACf,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,WAAW;QACX,2BAA2B;QAC3B,YAAY;QACZ,UAAU;MACZ;;MAEA;QACE,wBAAwB;QACxB,kCAAkC;MACpC;AACN;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,2BAA2B;QAC3B,6CAA6C;QAC7C,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;;QAEZ,cAAc;QACd,qCAAqC;QACrC,mBAAmB;QACnB,cAAc;IAClB;IACA;QACI,qBAAqB;QACrB,YAAY;QACZ,aAAa;QACb,eAAe;QACf,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,0EAA0E;QAC1E,wBAAwB;QACxB,6BAA6B;QAC7B,mBAAmB;QACnB,eAAe;QACf,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,WAAW;QACX,2BAA2B;QAC3B,YAAY;QACZ,UAAU;MACZ;;MAEA;QACE,wBAAwB;QACxB,kCAAkC;MACpC;AACN;AACA;;;;;;GAMG;;;AAGH;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,0EAA0E;IAC1E,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,yDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;;IAEf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB","sourcesContent":[".assetTableList{\n    width: 63%;\n    margin: auto;\n    margin-left: 14%;\n    border: solid black 1px;\n    border-radius: 8px;\n    border-spacing: 0;\n    border-collapse: separate;\n    border: var(--border);\n    overflow: hidden;\n}\n\n.assetIDHeader{\n  color: white;\n  font-size: 37px;\n  margin-left: 5%;\n  margin-top: -10%;\n}\n\n.assetTableList tbody tr:nth-child(even){\n    background-color: dimgray;\n    color: white;\n}\n\n.assetTableList tbody tr:nth-child(odd){\n    background-color: rgb(61, 61, 61);\n    color: white;\n}\n\n.assetTableList tr{\n    height: 40px;\n    transition: background-color 0.4s ease, transform 0                                                                                   .2s ease;\n    \n}\n\n.assetTableList thead{\n    color: white;\n    height: 40px;\n    background-color: #059bd4ff;\n}\n\n.assetTableList th{\n    border: solid  rgba(58, 57, 57, 0.251) 1px;\n    border-collapse: collapse;\n    text-align: center;\n    \n}\n\n.assetTableList td{\n    border: solid  black 1px;\n    border-collapse: collapse;\n    text-align: center;\n    height: 100%;\n}\n\n.assetTableList tr:hover {\n  background-color: rgb(3, 83, 114) !important; /* Change to your desired highlight color */\n}\n\n.logo {\n    grid-row-start: 1;\n    grid-row-end: 2;\n    height: 10%;\n    width: 90%;\n    margin: auto;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100%;\n    position: relative;\n    z-index: 1;\n    background-image: url(\"../../public/logos/KassetHorizontalLogoPlain.png\");\n}\n\n.sideNav {\n  display: block;\n  height: 100%;\n  width: 13%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  background-color: #111;\n  overflow-x: hidden;\n  transition: 0.5s;\n  padding-top: 20px;\n}\n\n.checkbox{\n  height: 25px;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: 0;\n  width: 25px;\n}\n\n.sideNav a {\n  padding: 8px 8px 8px 32px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #059bd4ff !important;\n  display: block;\n  transition: 0.3s;\n  border-bottom: solid #000000 1px;\n}\n\nh2 {\n  color: white;\n  margin-left: 40%;\n}\n\nh1 {\n  color: white;\n  margin-left: 14%;\n}\n\n.sideNav h5{\n  position: absolute;\n  bottom: 0;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  color: rgb(4, 105, 145) !important;\n}\n\n.sideNav a:hover {\n  color: rgb(4, 105, 145) !important;\n}\n\n.sideNavLinks{\n    margin-top: 15px;\n}\n\n.sideEdit {\n  height: 100%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  background-color: #111;\n  overflow-x: hidden;\n  transition: 0.3s ease;\n  padding-top: 60px;\n}\n\n.sideEdit input, select{\n    display: grid;\n    border-radius: 5px;\n}\n\n.sideEditForm{\n    display: grid;\n    grid-template-columns: 40% 60%;\n    margin-right: 3%;\n    margin-left: 3%;\n}\n\n.sideEdit .closeEditMenu {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 24px;\n  margin-left: 50px;\n  margin-top: 3%;\n  border: none;\n  background-color: rgba(0,0,0,0);\n  color: white;\n}\n\n.textbox {\n    display: grid;\n    font-family: -apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    color: #fff;\n    background-color: rgb(28,28,30);\n    box-shadow: 0 0 .4vw rgba(0,0,0,0.5), 0 0 0 .15vw transparent;\n    border-radius: 0.4vw;\n    border: none;\n    outline: none;\n    padding: 10px;\n    width: 100%;\n    transition: .4s;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    }\n\n.textbox:hover {\n  box-shadow: 0 0 0 .15vw rgba(135, 207, 235, 0.186);\n}\n\n.textbox:focus {\n  box-shadow: 0 0 0 .15vw skyblue;\n}\n\n.searchbox {\n    display: grid;\n    font-family: -apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif;\n    font-weight: 500;\n    font-size: .6vw;\n    color: #fff;\n    background-color: rgb(28,28,30);\n    box-shadow: 0 0 .4vw rgba(0,0,0,0.5), 0 0 0 .15vw transparent;\n    border-radius: 0.4vw;\n    border: none;\n    outline: none;\n    padding: 10px;\n    width: 100%;\n    transition: .4s;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.searchbox:hover {\n  box-shadow: 0 0 0 .15vw rgba(135, 207, 235, 0.186);\n}\n\n.searchbox:focus {\n  box-shadow: 0 0 0 .15vw skyblue;\n}\n\n.searchControls{\n    width: 20%;\n    margin-left: 14%;\n    display: grid;\n    grid-template-columns: 60% 40%;\n}\n\n.inputLabel{\n    display: grid;\n    width: 100%;\n    font-family: -apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif;\n    font-size: 20px;\n    color: white;\n    margin: auto;\n    justify-content: left;\n}\n\n.numberSelector{\n    margin: auto;\n    width: 150px;\n    max-height: 30px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.selectSelector{\n  margin-left: none;\n    width: 100%;\n    max-height: 30px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.sideEdit a {\n  padding: 8px 8px 8px 32px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #059bd4ff !important;\n  display: block;\n  transition: 0.3s;\n  border-bottom: solid #000000 1px;\n}\n\n.sideEdit h5{\n  position: absolute;\n  bottom: 0;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  color: rgb(4, 105, 145) !important;\n}\n\n.sideEdit a:hover {\n  color: rgb(4, 105, 145) !important;\n}\n\n.sideEditLinks{\n    margin-top: 15px;\n}\n\n.updateButton{\n    color: white;\n    background-color: rgb(4, 101, 139);\n    width: 46%;\n    margin-left: 2%;\n    height: 35px;\n    border: none;\n    border-radius: 10px;\n    transition: background-color 0.1s ease-in;\n}\n\n.updateButton:hover{\n    background-color: rgb(1, 68, 94);\n}\n\n.searchButton{\n    color: white;\n    background-color: rgb(4, 101, 139);\n    width: 40%;\n    height: 35px;\n    border: none;\n    border-radius: 10px;\n    margin: auto;\n    margin-left: 5%;\n    transition: background-color 0.1s ease-in;\n}\n\n.searchButton:hover{\n    background-color: rgb(1, 68, 94);\n    transition: background-color 0.1s ease-in;\n}\n\n.deleteButton{\n    color: white;\n    background-color: rgb(157, 0, 0);\n    width: 46%;\n    margin-left: 2%;\n    margin-top: 10%;\n    height: 35px;\n    border: none;\n    border-radius: 10px;\n    transition: background-color 0.1s ease-in;\n}\n\n.deleteButton:hover{\n    background-color: rgb(107, 1, 1);\n}\n\n\n\n@import '../../node_modules/fontawesome-free/css/fontawesome.min.css';\n\n@media only screen and (min-width: 400px) {\n    .loginPane {\n        display:  grid;\n        justify-content: center;\n        grid-template-columns: auto;\n        grid-template-rows: 500px 55px 55px 55px 55px;\n        grid-row-gap: 3%;\n        width: 20vw;\n        min-width: 400px;\n        min-height: 900px;\n        height: 100%;\n        margin: auto;\n        margin-top: 5%;\n        background-color: rgba(17, 17, 17, 1);\n        border-radius: 10px;\n        color: #ffffff;\n        \n    }\n\n    .normalButtons{\n        display: inline-block;\n        margin: auto;\n        outline: none;\n        cursor: pointer;\n        font-size: 14px;\n        line-height: 1;\n        border-radius: 10px;\n        transition-property: background-color,border-color,color,box-shadow,filter;\n        transition-duration: .3s;\n        border: 1px solid transparent;\n        letter-spacing: 2px;\n        min-width: 80px;\n        text-transform: uppercase;\n        white-space: normal;\n        font-weight: 700;\n        text-align: center;\n        padding: 16px 14px 18px;\n        color: #fff;\n        background-color: #059bd4ff;\n        height: 48px;\n        width: 80%;\n      }\n      \n      .normalButtons:hover {\n        transition-duration: .3s;\n        background-color: rgb(0, 121, 168);\n      }\n}\n\n@media only screen and (max-width: 400px) {\n    .loginPane {\n        display: grid;\n        justify-content: center;\n        grid-template-columns: auto;\n        grid-template-rows: 500px 55px 55px 55px 55px;\n        grid-row-gap: 3%;\n        width: 20vw;\n        min-width: 100%;\n        min-height: 600px;\n        height: 100%;\n        margin: auto;\n        \n        margin-top: 5%;\n        background-color: rgba(17, 17, 17, 1);\n        border-radius: 10px;\n        color: #ffffff;\n    }\n    .normalButtons{\n        display: inline-block;\n        margin: auto;\n        outline: none;\n        cursor: pointer;\n        font-size: 14px;\n        line-height: 1;\n        border-radius: 10px;\n        transition-property: background-color,border-color,color,box-shadow,filter;\n        transition-duration: .3s;\n        border: 1px solid transparent;\n        letter-spacing: 2px;\n        min-width: 80px;\n        text-transform: uppercase;\n        white-space: normal;\n        font-weight: 700;\n        text-align: center;\n        padding: 16px 14px 18px;\n        color: #fff;\n        background-color: #059bd4ff;\n        height: 48px;\n        width: 80%;\n      }\n      \n      .normalButtons:hover {\n        transition-duration: .3s;\n        background-color: rgb(0, 121, 168);\n      }\n}\n/* body {\n    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(\"../../../public/img/ticketbg.jpg\");\n    background-position: 0% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: relative;\n} */\n\n\n.linksButtons{\n    display: inline-block;\n    margin: 10px;\n    outline: none;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n    border-radius: 10px;\n    transition-property: background-color,border-color,color,box-shadow,filter;\n    transition-duration: .3s;\n    border: 1px solid transparent;\n    letter-spacing: 2px;\n    min-width: 80px;\n    text-transform: uppercase;\n    white-space: normal;\n    font-weight: 700;\n    text-align: center;\n    padding: 16px 14px 18px;\n    color: #fff;\n    background-color: rgb(3, 74, 103);\n    height: 48px;\n    width: 220px;\n}\n    \n.linksButtons:hover {\n    transition-duration: .3s;\n    background-color: rgb(0, 121, 168);\n}\n\n.title {\n    display: grid;\n    align-content: center;\n    justify-content: center;\n    grid-row-start: 2;\n    grid-row-end: 3;\n}\n\n.title h1 {\n    font-size: 42px;\n    align-content: center;\n    justify-content: center;\n}\n\n.smallLogo {\n    grid-row-start: 1;\n    grid-row-end: 2;\n    height: 500px;\n    width: 70%;\n    margin: auto;\n    margin-top: 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100%;\n    position: relative;\n    z-index: 1;\n    background-image: url(\"../../public/logos/Kasset.png\");\n}\n\n.formInput {\n    border: none;\n    background: none;\n    width: 85%;\n    height: 60%;\n    margin-top: 3%;\n    margin-left: 5%;\n    color: white;\n}\n\n.form-label {\n    font-size: 120%;\n    font-weight: bold;\n}\n\n.text-fields {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 25px;\n    margin-top: 0px;\n    height: 55px;\n    margin: auto;\n}\n\n.body{\n    background-color: rgba(0, 0, 0, 1);\n}\n\n.form{\n    background-color: rgba(0, 0, 0, 1);\n    height: 850px;\n}\n\n.loginRowEmail {\n    display: flex;\n    grid-row-start: 2;\n    grid-row-end: 3;\n    width: 90%;\n}\n\n.fa {\n    margin-left: 10%;\n    margin-top: 5.5%;\n}\n\n.loginRowPassword {\n    display: flex;\n    grid-row-start: 3;\n    grid-row-end: 4;\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 90%;\n}\n\n.btn-div {\n    display: flex;\n    grid-row-start: 4;\n    grid-row-end: 5;\n    \n    width: 100%;\n}\n\n.links-div{\n    display: flex;\n    grid-row-start: 5;\n    grid-row-end: 6;\n    width: 100%;\n}\n\n.links{\n    display: flex;\n    width: 100%;\n}\n\n.loginFormGroup {\n    width: fit-content;\n    text-align: center;\n}\n\n.form-control {\n    width: 75%;\n    text-align: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
